var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current != _vm.before)?_c('div',{class:{
    'success--text': _vm.current > _vm.before,
    'error--text': _vm.current < _vm.before
  }},[_c('v-icon',{attrs:{"color":_vm.current > _vm.before ? 'success' : 'error',"x-small":""}},[_vm._v(" "+_vm._s(_vm.current > _vm.before ? "mdi-arrow-up-bold" : "mdi-arrow-down-bold")+" ")]),_vm._v(" "+_vm._s(_vm.getGrowthPercent())+" % ")],1):_c('div',[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }